import { render, staticRenderFns } from "./UserDeptSelect.vue?vue&type=template&id=5f20bae6&scoped=true"
import script from "./UserDeptSelect.vue?vue&type=script&lang=js"
export * from "./UserDeptSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f20bae6",
  null
  
)

export default component.exports